<header class="site-header" id="top">
  <div class="container">
    <div class="identity">
      <a href="https://www.lincolnshire.gov.uk" class="identity__link" title="Lincolnshire County Council Home Page">
        <img src="assets/images/LCC-Logo-Dark.svg" class="identity__logo" alt="Logo: Lincolnshire County Council" />
      </a>
    </div>

    <form class="site-search" action="https://www.lincolnshire.gov.uk/site-search/results/" method="get" role="search">
      <label class="visually-hidden" for="search-site-header">Search</label>
      <div class="form__append-group">
        <input class="form__field" type="search" size="18" maxlength="40" name="q" placeholder="Search&hellip;"
          id="search-site-header" />
        <button class="button button--primary" type="submit">
          <svg class="icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path
              d="M15.5 14h-.79l-.28-.27A6.47 6.47 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5Zm-6 0A4.5 4.5 0 1 1 14 9.5 4.5 4.5 0 0 1 9.5 14Z" />
          </svg>
          <span class="visually-hidden">Search</span>
        </button>
      </div>
    </form>

    <nav class="nav nav--primary-navigation" aria-label="Main">
      <ul class="list list--inline navigation-buttons">
        <li class="list__item list__item--account">
          <a class="list__link account-link" href="https://www.lincolnshire.gov.uk/myaccount">
            <svg class="icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path d="M12 12a5 5 0 1 0-5-5 5 5 0 0 0 5 5Zm0 2.5c-3.34 0-10 1.67-10 5V22h20v-2.5c0-3.33-6.66-5-10-5Z" />
            </svg>
            <span class="button__text">My Account</span>
          </a>
        </li>
        <li class="list__item list__item--menu">
          <button type="button" class="list__link menu-toggle" [attr.aria-expanded]="menuOpen" aria-controls="js-menu"
            (click)="toggleMenu()">
            <span class="toggle-icon" [class.toggle-icon--open]="menuOpen">
              <span class="toggle-icon__line"></span>
            </span>
            <span class="button__text">{{ menuOpen ? 'Close' : 'Menu' }}</span>
          </button>
        </li>
      </ul>
    </nav>
  </div>

  <div class="menu-navigation" id="js-menu" [hidden]="!menuOpen">
    <div class="container">
      <nav class="nav" aria-label="Menu Navigation">
        <ul class="list">
          <li class="list__item" *ngFor="let item of menuItems">
            <a class="list__link" [href]="item.href">{{ item.label }}</a>
          </li>
        </ul>
      </nav>
    </div>
  </div>

</header>
